import createIcon from '../../createIcon';

/**
 * @component @name Preview
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuODkgMyAzIDMuOSAzIDVWMTlDMyAyMC4xIDMuODkgMjEgNSAyMUgxOUMyMC4xIDIxIDIxIDIwLjEgMjEgMTlWNUMyMSAzLjkgMjAuMTEgMyAxOSAzWk0xOSAxOUg1VjdIMTlWMTlaTTEzLjUgMTNDMTMuNSAxMy44MyAxMi44MyAxNC41IDEyIDE0LjVDMTEuMTcgMTQuNSAxMC41IDEzLjgzIDEwLjUgMTNDMTAuNSAxMi4xNyAxMS4xNyAxMS41IDEyIDExLjVDMTIuODMgMTEuNSAxMy41IDEyLjE3IDEzLjUgMTNaTTEyIDlDOS4yNyA5IDYuOTQgMTAuNjYgNiAxM0M2Ljk0IDE1LjM0IDkuMjcgMTcgMTIgMTdDMTQuNzMgMTcgMTcuMDYgMTUuMzQgMTggMTNDMTcuMDYgMTAuNjYgMTQuNzMgOSAxMiA5Wk0xMiAxNS41QzEwLjYyIDE1LjUgOS41IDE0LjM4IDkuNSAxM0M5LjUgMTEuNjIgMTAuNjIgMTAuNSAxMiAxMC41QzEzLjM4IDEwLjUgMTQuNSAxMS42MiAxNC41IDEzQzE0LjUgMTQuMzggMTMuMzggMTUuNSAxMiAxNS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Preview = createIcon('Preview', [
  [
    'path',
    {
      d: 'M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM19 19H5V7H19V19ZM13.5 13C13.5 13.83 12.83 14.5 12 14.5C11.17 14.5 10.5 13.83 10.5 13C10.5 12.17 11.17 11.5 12 11.5C12.83 11.5 13.5 12.17 13.5 13ZM12 9C9.27 9 6.94 10.66 6 13C6.94 15.34 9.27 17 12 17C14.73 17 17.06 15.34 18 13C17.06 10.66 14.73 9 12 9ZM12 15.5C10.62 15.5 9.5 14.38 9.5 13C9.5 11.62 10.62 10.5 12 10.5C13.38 10.5 14.5 11.62 14.5 13C14.5 14.38 13.38 15.5 12 15.5Z',
      key: '1vvvhr',
    },
  ],
]);

export default Preview;
